import React, { useEffect, useState, useReducer, createContext } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import Management from '../../common/Management';
import AnnotationsEditor from '../../common/AnnotationsEditor';
import HiresTable from './HiresTable';
import * as actionTypes from 'constants/ActionTypes';
import { postGazetters, removeGazetters } from 'actions/gazetters';
import { removeAnnotations } from 'actions/annotations';
import { removeLetter } from 'actions/letters';
import moment from 'moment';
import _ from 'lodash';
import { addNotification as _addNotification } from '../../../../actions/notifications/notifications';
import AnnotationsList from '../../common/AnnotationsList';
import api from 'services';
import { showNotification } from 'helpers';
import { reducer } from './hireOrdersReducer';
import { FlatButton } from 'material-ui';
import ErrorBoundary from '../../../common/ErrorBoundary';

export const ContextDispatchHireOrders = createContext(null);

function LetterHire(props) {
    const [servers, setServers] = useState({ annotationsServer: 'mailparse.net', clarifiedServer: 'standart' });
    const [annotations, setAnnotations] = useState([]);
    const [annotationsLoaded, setAnnotationsLoaded] = useState(false);
    const [updated, setUpdated] = useState(false);
    const [openedAttachmentsDialog, setOpenedAttachmentsDialog] = useState(false);
    const [modifiedTextLetter, setModifiedTextLetter] = useState(props.location.state ? props.location.state.modifiedTextLetter : '');
    const [initialTextLetter, setInitialTextLetter] = useState(props.location.state ? props.location.state.initialTextLetter : '');
    const [letter, setLetter] = useState({});

    const [stateHireOrders, dispatchHireOrders] = useReducer(reducer, []);

    const _getLetterData = async (editedText = '') => {
        try {
            setAnnotationsLoaded(false);
            const { data: _letter } = await api.getLetter(props.routeParams.id);

            setLetter(_letter);

            _letter.gazettersArr = [];
            _letter.type = 'hire';
            _letter.fromHireOrders = true;

            if (editedText) {
                _letter.text = editedText;
            }

            const annotationsResponse = await api.postAnnotations(
                _letter.text, 
                // _letter.type,
                'vessel', // temporal - due to nonexistant hire annotations server
                servers.annotationsServer, 
                { 
                    emailId: _letter._id,
                    subject: _letter.subject,
                    date: moment(_letter.date).format('DD-MM-YYYY'),
                },
            );

            if (annotationsResponse) {
                _letter.gazettersArr = annotationsResponse.data.annotations;
                setAnnotationsLoaded(true);
                setAnnotations(_letter.gazettersArr);
                if (annotationsResponse.data.newclarified) {
                    _letter.newclarified = annotationsResponse.data.newclarified;
                }
            }

            const clarifiedLetter = await api.updateLetter(_.omit(_letter, 'gazettersArr'), servers.clarifiedServer);

            setLetter(_.omit(_letter, 'gazettersArr'));

            if (clarifiedLetter.status === 200) {
                if (clarifiedLetter.data.clarified && clarifiedLetter.data.clarified.length > 0) {
                    // TODO: fill with hire orders when hire clarified arrives
                    dispatchHireOrders({ type: 'CLEAR_ORDERS' });
                } else {
                    showNotification('Hire orders were not created.', 'warning');
                    dispatchHireOrders({ type: 'CLEAR_ORDERS' });
                }
            } else {
                showNotification('Hire orders were not created.', 'warning');
                dispatchHireOrders({ type: 'CLEAR_ORDERS' });
            }
        } catch (e) {
            props.addNotification({
                type: actionTypes.ADD_NOTIFICATION,
                notification: {
                    title: 'Error',
                    message: e.errors.messages[0],
                    level: 'error',
                    _id: new Date().getMilliseconds(),
                    autoDismiss: 10,
                },
            });
        }
    };

    useEffect(() => {
        if (modifiedTextLetter) {
            _getLetterData(modifiedTextLetter);
        } else {
            _getLetterData();
        }

        return () => {
            props.removeGazetters();
            props.removeAnnotations();
            props.removeLetter();
        };
    }, []);

    const updatePostGazetters = async (_textLetter) => {
        setAnnotationsLoaded(false);
        setAnnotations([]);
        setUpdated(true);
        const _gazetters = await api.postGazetters(
            _textLetter,
            {
                emailId: letter._id,
                subject: letter.subject,
                date: moment(letter.date).format('DD-MM-YYYY'),
            },
        );

        setAnnotations(_gazetters.data.map((gazetter, key) => ({
            ...gazetter,
            id: key,
            state: '',
        })));
        setAnnotationsLoaded(true);
    };

    const addOrderTable = () => {
        dispatchHireOrders({ type: 'ADD_ORDER' });
    };

    const removeOrderTable = () => {
        dispatchHireOrders({ type: 'REMOVE_ORDER' });
    };

    const clearOrderTable = () => {
        dispatchHireOrders({ type: 'CLEAR_ORDERS' });
    };

    /**
     * @param {import('../../../../mocks/hire/order').HireOrderRaw} order 
     */
    const checkForErrors = (order) => {
        const {
            vesselData, hire, hireType, delivery, redelivery, 
        } = order;

        /** @type {{ field: string, message: string }[]} */
        const errors = [];

        if (!vesselData._id) errors.push({ field: 'vesselName', message: 'Vessel ID is required.' });

        if (!hire) errors.push({ field: 'hire', message: 'Hire value is required' }); 

        if (!hireType) errors.push({ field: 'hireType', message: 'Hire type is required' }); 

        if (!delivery._id) errors.push({ field: 'delivery', message: 'Delivery is required' }); 

        if (!redelivery._id) errors.push({ field: 'redelivery', message: 'Redelivery is required' }); 

        return errors;
    };

    /**
     * @param {import('../../../../mocks/hire/order').HireOrderRaw} order 
     */
    const prepareHire = (order) => {
        const {
            vesselData, cargo, cargoRegion, delivery, redelivery, hire,
        } = order;
        return {
            ..._.pick(order, ['hireType', 'duration', 'lay', 'can']),
            cargoId: cargo ? cargo._id : undefined,
            vesselId: vesselData ? vesselData._id : undefined,
            cargoRegionId: cargoRegion ? cargoRegion._id : undefined,
            delivery: delivery._id,
            redelivery: redelivery._id,
            mailId: letter._id,
            hire: parseFloat(hire),
        };
    };

    const sendRequestHire = async () => {
        console.log(stateHireOrders);

        let hasErrors = false;

        stateHireOrders.forEach((order, index) => {
            const errors = checkForErrors(order);

            if (errors.length) {
                hasErrors = true;
                errors.forEach(error => showNotification(`Hire #${index + 1} --- ${error.message}`, 'error', { autoDismiss: 20 }));
            }
        });

        if (hasErrors) return;

        const preparedHires = stateHireOrders.map(h => prepareHire(h));

        const results = await Promise.all(preparedHires.map(h => api.postRequestHire(h))).catch(e => showNotification(e.message));

        results && results.forEach((res, index) => {
            if (res.errors.length) {
                showNotification(`Hire #${index + 1} --- ${res.errors[0].messages[0]}`, 'error', { autoDismiss: 20 });
            } else {
                showNotification('Success hire request', 'success', { autoDismiss: 20 });
            }
        });
    };
    
    return (
        <div id='single-letter-hire' className='single-letter'>
            <div className='content' style={{ width: '60vw' }}>
                <Management 
                    getLetterData={_getLetterData}
                    openedAttachmentsDialog={openedAttachmentsDialog}
                    originalText={initialTextLetter || letter.text}
                    routeParams={props.routeParams}
                    router={props.router}
                    textLetter={modifiedTextLetter || letter.text}
                    toggleAttachmentsDialog={() => setOpenedAttachmentsDialog(!openedAttachmentsDialog)}
                    updatePostGazetters={updatePostGazetters}
                    servers={servers}
                    setServers={setServers}
                    letter={letter}
                />
                {
                    updated ?
                        (
                            <ErrorBoundary>
                                <AnnotationsEditor letterText={letter.text} />
                            </ErrorBoundary>
                        )
                        :
                        (
                            <ErrorBoundary>
                                <AnnotationsEditor letterText={modifiedTextLetter || letter.text} />
                            </ErrorBoundary>
                        )
                }
                <ErrorBoundary>
                    <AnnotationsList annotations={annotations} annotationsLoaded={annotationsLoaded} />
                </ErrorBoundary>
            </div>
            <div className='sidebar' style={{ width: '40vw' }}>
                <h1>Hire orders</h1>
                <ErrorBoundary>
                    <ContextDispatchHireOrders.Provider value={dispatchHireOrders}>
                        {
                            stateHireOrders.map((o, i) => <HiresTable key={`hireOrder_${i}`} hireOrderNumber={i} hireOrder={o} />)
                        }
                    </ContextDispatchHireOrders.Provider>
                </ErrorBoundary>
                <ul className='controller-orders' style={{ width: '40vw' }}>
                    <li>
                        <FlatButton style={{ color: 'white' }} onClick={addOrderTable} label='Add' />
                    </li>
                    <li>
                        <FlatButton style={{ color: 'white' }} onClick={removeOrderTable} label='Remove' />
                    </li>
                    <li>
                        <FlatButton style={{ color: 'white' }} onClick={clearOrderTable} label='Clear' />
                    </li>
                    <li>
                        <FlatButton style={{ color: 'white' }} onClick={sendRequestHire} label='Send' />
                    </li>
                </ul>
            </div>
        </div>
    );
}

export default connect(
    null,
    dispatch => bindActionCreators({
        postGazetters,
        removeGazetters,
        removeAnnotations,
        removeLetter,
        addNotification: _addNotification,
    }, dispatch),
)(LetterHire);



// WEBPACK FOOTER //
// ./app/components/Letters/SingleNew/Hire/LetterHire.jsx